export const ru = {
    error: 'Произошла ошибка',
    'no-campaign-found': 'Кампании не найдены',
    'search-by-campaign': 'Поиск по кампаниям'
};
